var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoroccoMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Morocco (MA)",
    clipPath: "url(#clip0_11_1554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_1554",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: 0,
    width: 32,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_810_8519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 0H-4V24H28V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_1554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28 0H-4V24H28V0Z",
    fill: "#E70013"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0002 6.96777L8.77038 17.0323L17.226 10.8246H6.77441L15.2301 17.0323L12.0002 6.96777Z",
    stroke: "#006233",
    strokeWidth: 0.5
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_1554"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white",
    transform: "translate(-4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoroccoMa);
export default __webpack_public_path__ + "static/media/Morocco (MA).ac95e33b84a30bb012cf1208d03f76e6.svg";
export { ForwardRef as ReactComponent };